import React from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'redux/index'

import App from './web/components/App/App';

import 'floating-label-react/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import * as serviceWorker from './serviceWorker';
import './web/styles/paymentFont.min.css';

import './web/styles/_form.scss';
import './web/styles/index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

// import * as Sentry from "@sentry/react";

// Sentry.init({
//     environment: "QA",
//     dsn: "https://8ec7c338f04086aafd671e6d476b80b0@o4507973689540608.ingest.us.sentry.io/4507973717983232",
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration({
//             maskAllText: false
//         }),
//     ],
//     // Tracing
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: [
//         /* Support env URLs */
//         // /^(http|https):\/\/support-bettaway-ui-env\.eba-39hhhkw4\.us-east-1\.elasticbeanstalk\.com/,
//         // /^(http|https):\/\/support-ptms-service-env\.eba-kpffq3ej\.us-east-1\.elasticbeanstalk/,
//         // /^(http|https):\/\/support-zull-service-env\.eba-uqdppyki\.us-east-1\.elasticbeanstalk/
//         /* QA env URLs */
//         /^(http|https):\/\/bettawayui-env\.eba-sti3ipyi\.us-east-1\.elasticbeanstalk/,
//         /^(http|https):\/\/zull-service-env\.eba-m2b8mgqz\.us-east-1\.elasticbeanstalk/,
//         /^(http|https):\/\/ptms-service-env\.eba-ppypzmqp\.us-east-1\.elasticbeanstalk/
//     ],
//     // Session Replay
//     // This sets the sample rate at 10%.
//     // You may want to change it to 100% while in development
//     // and then sample at a lower rate in production.
//     replaysSessionSampleRate: 0.1,
//     // If you're not already sampling the entire session,
//     // change the sample rate to 100% when sampling sessions where errors occur.
//     replaysOnErrorSampleRate: 1.0,
// });

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
